import { secureGet, securePost, securePut, secureDelete } from "../../Config/ApiConfig";


export const getUser = async (id) => {
    const { data } = await secureGet('/users/me');
    return data;
};


export const updateUser = async (body) => {
    const { data } = await securePut('/users/me', body);
    return data;
};

export const sendVerificationEmail = async (id, body) => {
    const { data } = await securePost('/users/me/resend-verification-email', body);
    return data;
};

export const uploadProfileFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    const { data } = await securePost('/file-uploads', formData, config);
    return data;
};

export const deleteProfilePicture = async () => {
    const { data } = await secureDelete('/users/me/profile-picture');
    return data;
};